import React, {Component, ReactElement} from 'react'
import {getQueryParameter, getQueryParameters} from '../../common/util/Natutil'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {NatAdminLoginInfoSessionStorageHelper} from '../../common/authentication/NatAdminLoginInfoSessionStorageHelper'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {AdminUserLoginInfo} from '../login/repository/AdminUserLoginInfo'
import {Messages} from '../../../Messages'
import {Location} from 'react-router-dom'

interface Props {
    location: Location
}

class NatAdminAdSSOLoginRedirectPage extends Component<Props & AdminPagePropsSet> {
    constructor(props: Props & AdminPagePropsSet) {
        super(props)
    }

    async componentDidMount(): Promise<void> {
        SessionStorageHelper.removeAllItem()

        const result: AdminUserLoginInfo = this.convertQueryParameterIntoAdminAdSsoLoginUserInfo()
        const urlAfterLogin = getQueryParameter('urlAfterLogin', window.location.search)
        const selectedCondominiumCd = getQueryParameter('selectedCondominiumCd', window.location.search)
        const selectedCondominiumName = getQueryParameter('selectedCondominiumName', window.location.search)
        const errorMessage = getQueryParameter('errorMessage', window.location.search)
        if (errorMessage) {
            this.props.navigate(
                '/admin/error',
                {state: {message: errorMessage}},
            )
            return
        }

        if (urlAfterLogin) {
            NatAdminLoginInfoSessionStorageHelper.setSessionStorage(result)
            if (selectedCondominiumCd) {
                NatAdminLoginInfoSessionStorageHelper.setSessionStorageForCondominiumMode(
                    result.authority,
                    selectedCondominiumCd,
                    selectedCondominiumName,
                )
            }
            this.props.navigate(urlAfterLogin)
        } else {
            this.props.navigate(
                '/admin/error',
                {state: {message: Messages.EOPCC0042.toString('管理者様向けサービス')}},
            )
        }
    }

    convertQueryParameterIntoAdminAdSsoLoginUserInfo(): AdminUserLoginInfo {
        const authority = getQueryParameters('authority', window.location)

        const queryCondominiumGroupId = getQueryParameter('condominiumGroupId', window.location.search)
        const belongCondominiumGroupId = (queryCondominiumGroupId) ? Number(queryCondominiumGroupId) : null

        return {
            authority: authority,
            role: getQueryParameter('role', window.location.search),
            roleName: getQueryParameter('roleName', window.location.search),
            adminId: getQueryParameter('adminId', window.location.search),
            familyName: getQueryParameter('familyName', window.location.search),
            firstName: getQueryParameter('firstName', window.location.search),
            condominiumGroupId: belongCondominiumGroupId,
            condominiumGroupName: getQueryParameter('condominiumGroupName', window.location.search),
            condominiumCd: getQueryParameter('condominiumCd', window.location.search),
            condominiumName: getQueryParameter('condominiumName', window.location.search),
            passwordUnstrengthFlag: '',
            mode: getQueryParameter('mode', window.location.search),
            errorInfo: null,
        }
    }

    render(): Nullable<ReactElement> {
        return (
            <>
            </>
        )
    }
}

export default createAdminPage(NatAdminAdSSOLoginRedirectPage)
